import wixLocation from 'wix-location';

export function iconButton1_click(event) {
    console.log('in click');
    let text = $w('#input6').value;
    console.log('text: ', text);
    if (text !== '') {  // Something in the text box
	wixLocation.to('http://hsp.org/search/node/' + text);
    console.log('beyond to');
  }
}

// Search button clicked. Take the search text and send it to one of three search processes depending on the setting of the dropdown.

export function searchButton_click(event) {
    // Icon from www.flatiron.com
	let searchText = $w('#searchText').value; // Fetch contents of text box, if any
    if (searchText !== "") { // If !== there is something in the box. We have work to do
        let searchDropdown = $w('#searchDropdown').value; // Fetch selection of dropdown list
        let searchDispatch = ''; // Initialize the URL that will actually do the search
        console.log('search text: ', searchText, 'searchDropdown: ', searchDropdown);
        switch ($w('#searchDropdown').value) {
            case 'Website': {
                console.log('Website');
                searchDispatch = 'http://hsp.org/search/node/' + searchText;
                break;
            }
            case 'Collections': {
                console.log('Collections');
                searchDispatch = 'http://discover.hsp.org/search/Results?lookfor=' + searchText;
                break;
            }
            case 'Journals': {
                console.log('Journals');
                searchDispatch = 'http://jstor.org/action/doBasicSearch?Query=(' + searchText + ') AND jid:(j50000717 OR j50000118)';
                break;
            }
            default:
                break;
        }
        console.log('clear of switch, searchDispatch: ', searchDispatch);
        wixLocation.to(searchDispatch); // Chain to the appropriate search page
    } 
}